<template>
    <ml-layout>
        <div class="ml-main">
            <el-card shadow="never">
                <div slot="header" class="clearfix">
                    <span>{{ status }}虚拟仿真实验项目</span>
                </div>
                <el-form :model="form" label-width="80px">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="项目名称" prop="title">
                                <el-input
                                    v-model="form.title"
                                    placeholder="请输入项目名称"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="实验名称" prop="expId">
                                <el-select
                                    v-model="form.expId"
                                    filterable
                                    remote
                                    :remote-method="getRemoteExpList"
                                    :loading="expList.loading"
                                    placeholder="请选择实验"
                                    class="ml-select"
                                >
                                    <el-option
                                        v-for="item in expList.data"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="视频封面">
                                <el-upload
                                    class="uploader img-uploader"
                                    :show-file-list="false"
                                    :action="uploadsFile"
                                    :on-success="uploadVideoImgSuccess"
                                    :on-progress="uploadVideoImgProgress"
                                    :on-error="uploadVideoImgError"
                                >
                                    <img
                                        v-if="form.videoImg"
                                        :src="form.videoImg"
                                        class="uploader-image"
                                    />
                                    <i
                                        v-if="
                                            !videoImgProgress && !form.videoImg
                                        "
                                        class="el-icon-plus uploader-icon"
                                    ></i>
                                    <el-progress
                                        :width="40"
                                        v-if="videoImgProgress"
                                        type="circle"
                                        :percentage="videoImgProgress"
                                    ></el-progress>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="简介视频">
                                <el-upload
                                    :action="uploadsFile"
                                    :file-list="videoList"
                                    :on-success="uploadVideoSuccess"
                                    :on-error="uploadVideoError"
                                >
                                    <el-button size="small" type="primary">
                                        点击上传
                                    </el-button>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="项目描述">
                                <el-input
                                    autosize
                                    type="textarea"
                                    v-model="form.des"
                                    placeholder="请输入项目描述"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <el-divider content-position="left">
                        学校相关配置
                    </el-divider>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="学校名称" prop="schoolId">
                                <el-select
                                    v-model="form.schoolId"
                                    filterable
                                    remote
                                    :remote-method="getRemoteSchoolList"
                                    :loading="form.loading"
                                    placeholder="请选择学校"
                                    class="ml-select"
                                >
                                    <el-option
                                        v-for="item in schoolList.data"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="学校Logo">
                                <el-upload
                                    class="uploader logo-uploader"
                                    :show-file-list="false"
                                    :action="uploadsFile"
                                    :on-success="uploadLogoSuccess"
                                    :on-progress="uploadLogoProgress"
                                    :on-error="uploadLogoError"
                                >
                                    <img
                                        v-if="form.logo"
                                        :src="form.logo"
                                        class="uploader-image"
                                    />
                                    <i
                                        v-if="!logoProgress && !form.logo"
                                        class="el-icon-plus uploader-icon"
                                    ></i>
                                    <el-progress
                                        :width="40"
                                        v-if="logoProgress"
                                        type="circle"
                                        :percentage="logoProgress"
                                    ></el-progress>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="团队json">
                                <el-input
                                    autosize
                                    type="textarea"
                                    v-model="form.teamJson"
                                    placeholder="请输入团队Json"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-divider content-position="left">
                        ilab-x相关配置
                    </el-divider>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="项目名称">
                                <el-input
                                    v-model="form.iLabXTitle"
                                    placeholder="请输入ilab-x项目名称"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="项目类别" prop="iLabXLabId">
                                <el-select
                                    v-model="form.iLabXLabId"
                                    filterable
                                    remote
                                    :remote-method="getRemoteILabXLabList"
                                    :loading="iLabXLabList.loading"
                                    placeholder="请选择ilab-x项目类别"
                                    class="ml-select"
                                >
                                    <el-option
                                        v-for="item in iLabXLabList.data"
                                        :key="item.id"
                                        :label="item.category_name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8"></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="secret" prop="secret">
                                <el-input
                                    v-model="form.secret"
                                    placeholder="请输入secret"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="aesKey" prop="aesKey">
                                <el-input
                                    v-model="form.aesKey"
                                    placeholder="请输入aesKey"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="issuerId" prop="issuerId">
                                <el-input
                                    v-model="form.issuerId"
                                    placeholder="请输入issuerId"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                </el-form>
                <el-row>
                    <el-button
                        type="primary"
                        class="submit"
                        @click="handleSubmit"
                    >
                        提交
                    </el-button>
                </el-row>
            </el-card>
        </div>
    </ml-layout>
</template>

<script>
import {
    getExpList,
    getSchoolList,
    uploadsFile,
    getVirtualCategoryList,
    updateVirtualSimulation
} from "@/api/views/expInfo";

import { showVirtualSimulation } from "@/api/views/home";

import { getSessionRequest } from "@/api/components/mlLayout";

import MlLayout from "@/components/MlLayout";

export default {
    name: "ExpInfo",
    components: {
        MlLayout
    },
    data() {
        return {
            status: "添加",
            id: null,
            // 实验列表
            expList: {
                data: [],
                loading: false
            },
            // 学校列表
            schoolList: {
                data: [],
                loading: false
            },
            // ilab-x分类列表
            iLabXLabList: {
                data: [],
                loading: false
            },
            // 上传图片地址
            uploadsFile: uploadsFile,
            // 视频封面上传进度
            videoImgProgress: null,
            // 学校Logo上传进度
            logoProgress: null,
            // 视频列表
            videoList: [],
            form: {
                title: null,
                expId: null,
                videoImg: null,
                video: null,
                des: null,
                fuzeren: null
            }
        };
    },
    created() {
        let id = this.$route.query.id;
        if (id) {
            this.id = id;
            this.status = "修改";
            showVirtualSimulation({
                id: id,
                page: 1,
                showNum: 1
            }).then(res => {
                if (1 === res.code) {
                    this.form.title = res.virtualList[0].title;
                    this.expList = [
                        {
                            id: res.virtualList[0].exp_id,
                            name: res.virtualList[0].exp_name
                        }
                    ];
                    this.form.expId = res.virtualList[0].exp_id;
                    this.form.videoImg = res.virtualList[0].video_img;
                    this.form.video = res.virtualList[0].video;
                    this.videoList.push({
                        name: "video",
                        url: res.virtualList[0].video
                    });
                    this.form.des = res.virtualList[0].des;
                }
            });
        }

        this.getSessionInfo();
    },
    methods: {
        updateUserInfo(userInfo, status = true) {
            this.loginStatus = status;
            this.loginUserInfo = userInfo;
            this.$store.commit("updateUserInfo", userInfo);
        },
        // 获取用户session的信息
        getSessionInfo() {
            getSessionRequest().then(res => {
                // 拿到session信息，更新一下
                if (res.userinfo === "") {
                    // 未登录
                    this.updateUserInfo({}, false);
                    this.$router.push("/");
                } else {
                    // 已登录
                    this.updateUserInfo(res.userinfo);
                }
            });
        },
        // 获取实验列表
        getRemoteExpList(query) {
            if (query !== "") {
                this.expList.loading = true;
                getExpList({ expName: query }).then(res => {
                    this.expList.data = res.expList;
                    this.expList.loading = false;
                });
            } else {
                this.expList.data = [];
            }
        },
        // 获取学校列表
        getRemoteSchoolList(query) {
            if (query !== "") {
                this.schoolList.loading = true;
                getSchoolList({ query: query }).then(res => {
                    this.schoolList.data = res.schoolList;
                    this.schoolList.loading = false;
                });
            } else {
                this.schoolList.data = [];
            }
        },
        // 获取ilab-x分类列表
        getRemoteILabXLabList(query) {
            if (query !== "") {
                this.iLabXLabList.loading = true;
                getVirtualCategoryList({ query: query }).then(res => {
                    this.iLabXLabList.data = res.data;
                    this.iLabXLabList.loading = false;
                });
            } else {
                this.iLabXLabList.data = [];
            }
        },
        // 视频封面上传成功
        uploadVideoImgSuccess(res) {
            this.form.videoImg = res.path;
            this.videoImgProgress = null;
            // 嵌套太深了，强制刷新
            this.$forceUpdate();
        },
        // 视频封面上传进度
        uploadVideoImgProgress(event) {
            this.videoImgProgress = parseInt(event.percent);
        },
        // 视频封面上传失败
        uploadVideoImgError() {
            this.videoImgProgress = null;
            this.$message.error("上传失败");
        },
        // 学校Logo上传成功
        uploadLogoSuccess(res, file) {
            this.form.logo = URL.createObjectURL(file.raw);
            this.logoProgress = null;
            // 嵌套太深了，强制刷新
            this.$forceUpdate();
        },
        // 学校Logo上传进度
        uploadLogoProgress(event) {
            this.logoProgress = parseInt(event.percent);
        },
        // 学校Logo上传失败
        uploadLogoError() {
            this.logoProgress = null;
            this.$message.error("上传失败");
        },
        // 视频上传成功
        uploadVideoSuccess(res, info) {
            this.form.video = res.path;
            this.videoList = [
                {
                    name: info.name,
                    url: res.path
                }
            ];
        },
        // 视频上传失败
        uploadVideoError() {
            this.$message.error("上传失败");
        },
        // 提交
        handleSubmit() {
            updateVirtualSimulation({
                id: this.id || null,
                exp_id: this.form.expId || "",
                school_id: this.form.schoolId || "",
                video: this.form.video || "",
                logo: this.form.logo || "",
                title: this.form.title || "",
                video_img: this.form.videoImg || "",
                team_json: this.form.teamJson || "",
                secret: this.form.secret || "",
                aesKey: this.form.aesKey || "",
                issueId: this.form.issuerId || "",
                projecttitle: this.form.iLabXTitle || "",
                nlab_id: this.form.iLabXLabId || "",
                des: this.form.des,
                fuzeren: this.$store.state.userInfo.name
            }).then(res => {
                if (0 < res.code) {
                    this.$message.success("提交成功");
                } else {
                    this.$message.error("提交失败");
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
$width: 288px;
$height: 0px;

.img-uploader {
    $height: $width / 3 * 2;
    height: $height;

    .uploader-icon {
        line-height: $height;
    }
}

.logo-uploader {
    $height: $width / 3;
    height: $height;

    .uploader-icon {
        line-height: $height;
    }
}

.uploader {
    width: $width;

    /deep/ .el-upload {
        height: 100%;
        width: 100%;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
            border-color: #409eff;
        }
    }

    .uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 100%;
        text-align: center;
    }

    .uploader-image {
        width: 100%;
        height: 100%;
        display: block;
    }

    .el-progress {
        position: absolute;
        top: 40%;
        left: 43%;
    }
}

.submit {
    width: 200px;
    float: right;
}
</style>
